<template>
  <div class="flex flex-wrap items-center gap-x-8 gap-y-4 md:gap-16">
    <PublicationUpdateDate
      v-if="content.updateDate"
      class="body-2"
      :update-date="content.updateDate"
    />

    <RevDivider v-if="content.updateDate" class="h-20" variant="vertical" />

    <ReadTime class="body-2" :content />

    <RevDivider class="h-20" variant="vertical" />

    <ShareArticle />
  </div>
</template>

<script setup lang="ts">
import type { ArticlePageContent } from '@backmarket/http-api/src/api-specs-content/models/article-page-content'
import type { MappedApiPageContent } from '@backmarket/http-api/src/api-specs-content/models/base-page-content'
import { RevDivider } from '@ds/components/Divider'

import PublicationUpdateDate from './PublicationUpdateDate/PublicationUpdateDate.vue'
import ReadTime from './ReadTime/ReadTime.vue'
import ShareArticle from './ShareArticle/ShareArticle.vue'

defineProps<{ content: MappedApiPageContent<ArticlePageContent> }>()
</script>
